/*
 *	@Author: ruanxiang
 *	@Date: 2020-01-16 20:39:33
 *	@Last Modified time: 2020-01-16 20:39:33
 *	@Explain: 
*/
import request from '@/utils/service';
import { getLocal } from '@/utils/index';
const api = {
  parkRecordAppeal: () => {
    // 获取账单申诉详情信息
    return request({
      url: '/charge/v2/api/parkOrderAppeals/msp',
      method: 'get',
      params: {
        uniqueId: getLocal('uniqueId'),
        parkId: getLocal('parkId')
      }
    });
  },
  detail: (data) => {
    // 获取账单详情信息
    return request({
      url: '/charge/v2/api/parkOrders/msp/detail',
      // url: '/devPass/api/parkRecord/msp/detail',
      method: 'POST',
      data
    });
  },
  plateNo: (params) => {
    // 根据车牌查询待缴费停车记录数
    return request({
      url: '/charge/v2/api/parkOrders/msp/plateNo',
      method: 'get',
      params
    });
  },
  bill: (data) => {
    // 停车帐单支付下单
    if(localStorage.getItem('collectorCode')){
      data.collectorCode = localStorage.getItem('collectorCode');
    }
    return request({
      url: '/charge/v2/api/payCharges',
      method: 'post',
      data
    });
  },
  payRecords: (params) => {
    // 获取已支付记录
    return request({
      url: '/charge/v2/api/parkOrders/msp/payRecords',
      method: 'get',
      params
    });
  },
  usableCoupons: (params) => {
    // 获取停车账单可使用的优惠券
    return request({
      url: '/charge/v2/api/parkOrders/msp/usableCoupons',
      method: 'get',
      params
    });
  },
  paySync: (params) => {
    // 获取停车缴费业务办理状态
    return request({
      url: '/charge/v2/api/payCharges/sync/' + params,
      method: 'get'
    });
  },
  getUserCountUnfinished:() =>{
    // 获取待缴费停车帐单个数
    return request({
      url: '/charge/v2/api/parkOrders/msp/countUnfinished',
      method: 'get'
    });
  },
  getUserPlateList:()=>{
    // 获取驾驶人车牌信息
    return request({
      url: '/charge/v2/api/parkOrders/msp/driverPlate',
      method: 'get'
    });
  },
  getPayTypesFetch:(params)=>{
    // 获取支付能力集
    return request({
      url: '/dealer/v2/api/parkPayTypesFetch',
      method: 'get',
      params
    });
  },
  creatBillArrears:(data)=>{
    // 创建欠费账单批量补缴下单
    if(localStorage.getItem('collectorCode')){
      data.collectorCode = localStorage.getItem('collectorCode');
    }
    return request({
      url: '/charge/v2/api/payCharges/batch',
      method: 'post',
      data
    });
  },
  getInvoiceUrl:(params)=>{
    // 获取支付能力集
    return request({
      url: '/invoice/v2/api/getInvoiceUrlByUnid',
      method: 'get',
      params
    });
  },
  getPayModel:()=>{
    // 获取支付模式
    return request({
      url: '/pay/v2/api/payModel',
      method: 'get',
    });
  },
  evaluations:(data)=>{
    // 停车账单评价(一次停车行为最多评价一次)
    return request({
      url: '/charge/v2/api/evaluations',
      method: 'post',
      data
    });
  },
  canbeEvaluate:(data)=>{
    // 停车账单是否可评价
    return request({
      url: '/charge/v2/api/canbeEvaluate',
      method: 'post',
      data
    });
  },
  getPassImg(params){
    // 获取出入车图片
    return request({
      url: '/charge/v2/api/parkOrders/msp/parkingPictures',
      method: 'get',
      params
    });
  },
  driverActiveCarOut:(data)=>{
    // 停车账单是否可评价
    return request({
      url: '/charge/v2/api/driverActiveCarOut',
      method: 'post',
      data
    });
  }

};

export default api;